import { useState } from "react";

import PropTypes from "prop-types";

import Card from "react-bootstrap/Card";

import Container from "react-bootstrap/Container";

import Badge from "react-bootstrap/Badge";

import { AgGridColumn, AgGridReact } from "ag-grid-react";

import { useTranslation } from "react-i18next";

import { useHistory } from "react-router-dom";

import { GET_DOCUMENT_BY_ID_AWAITING_ID } from "../../constants/stringConstants";

import Loader from "../../utils/Loader";

import dateformat from "dateformat";

import iconsSortUp from "../../assets/svg/icons-sortUp.svg";

import { formatDate } from "../../utils/formatDate";

import Col from "react-bootstrap/Col";
import DOMPurify from "dompurify";

const DocumentOverviewSmallContainer = ({ document, similarDocuments }) => {
  const { t } = useTranslation(),
    history = useHistory(),
    [showDescription, setShowDescription] = useState(false),
    [showKeywords, setShowKeywords] = useState(false),
    [showExtractedDates, setShowExtractedDates] = useState(false),
    [showSentiment, setShowSentiment] = useState(false);

  const sanitizer = DOMPurify.sanitize;

  return (
    <Container expand="lg" className="document-overview-small-container">
      <Card className="document-description-small-container-card">
        <Card.Header
          className="cursor-pointer"
          onClick={() => {
            if (!showDescription) setShowDescription(true);
            else setShowDescription(false);
          }}
        >
          {t("description")}
          <img
            width={24}
            height={24}
            className={
              !showDescription
                ? "arrow-icon arrow-icon-down cursor-pointer"
                : "display-none"
            }
            src={iconsSortUp}
            onClick={() => setShowDescription(true)}
          />
          <img
            width={24}
            height={24}
            className={
              !showDescription
                ? "display-none"
                : "arrow-icon arrow-icon-up cursor-pointer"
            }
            onClick={() => setShowDescription(false)}
            src={iconsSortUp}
          />
        </Card.Header>
        <Card.Body className={showDescription ? "" : "display-none"}>
          {/* <Card.Text>{document.news_summary}</Card.Text> */}
          <Card.Text
            dangerouslySetInnerHTML={{
              __html: sanitizer(document.news_summary),
            }}
          />
        </Card.Body>
      </Card>
      <Card className="document-keywords-small-container-card">
        <Card.Header
          className="cursor-pointer"
          onClick={() => {
            if (!showKeywords) setShowKeywords(true);
            else setShowKeywords(false);
          }}
        >
          {t("keywords")}{" "}
          <img
            width={24}
            height={24}
            className={
              !showKeywords
                ? "arrow-icon arrow-icon-down cursor-pointer"
                : "display-none"
            }
            src={iconsSortUp}
            onClick={() => setShowKeywords(true)}
          />
          <img
            width={24}
            height={24}
            className={
              !showKeywords
                ? "display-none"
                : "arrow-icon arrow-icon-up cursor-pointer"
            }
            onClick={() => setShowKeywords(false)}
            src={iconsSortUp}
          />
        </Card.Header>
        <Card.Body className={showKeywords ? "" : "display-none"}>
          <Card.Text>
            {document.keywords ? (
              document.keywords.map((keyword, index) => {
                return (
                  <Badge
                    key={"large-screen-news_topic-badge" + index}
                    className="news-topic-document-badge fs-10"
                  >
                    {keyword.description}
                  </Badge>
                );
              })
            ) : (
              <></>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="document-extracted-dates-small-container-card">
        <Card.Header
          className="cursor-pointer"
          onClick={() => {
            if (!showExtractedDates) setShowExtractedDates(true);
            else setShowExtractedDates(false);
          }}
        >
          {t("extractedDates")}{" "}
          <img
            width={24}
            height={24}
            className={
              !showExtractedDates
                ? "arrow-icon arrow-icon-down cursor-pointer"
                : "display-none"
            }
            src={iconsSortUp}
            onClick={() => setShowExtractedDates(true)}
          />
          <img
            width={24}
            height={24}
            className={
              !showExtractedDates
                ? "display-none"
                : "arrow-icon arrow-icon-up cursor-pointer"
            }
            onClick={() => setShowExtractedDates(false)}
            src={iconsSortUp}
          />
        </Card.Header>
        <Card.Body className={showExtractedDates ? "" : "display-none"}>
          <Card.Text>
            {document.found_dates ? (
              <>
                {document.found_dates.map((found_date, index) => {
                  return (
                    <div
                      key={"large-screen-found-date" + index}
                      className="found-date-document fs-14"
                    >
                      <Col className="found-date-document-description">
                        {dateformat(
                          new Date(found_date.description),
                          "mmmm d, yyyy"
                        )}
                      </Col>
                      <Col className="found-date-document-comment">
                        {found_date.comment}
                      </Col>
                    </div>
                  );
                })}
                <hr
                  className={
                    document.found_dates.length > 0
                      ? "found-date-divider"
                      : "display-none"
                  }
                />
              </>
            ) : (
              <> </>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="document-keywords-small-container-card">
        <Card.Header
          className="cursor-pointer"
          onClick={() => {
            if (!showSentiment) setShowSentiment(true);
            else setShowSentiment(false);
          }}
        >
          {t("sentiment")}
          <img
            width={24}
            height={24}
            className={
              !showSentiment
                ? "arrow-icon arrow-icon-down cursor-pointer"
                : "display-none"
            }
            src={iconsSortUp}
            onClick={() => setShowSentiment(true)}
          />
          <img
            width={24}
            height={24}
            className={
              !showSentiment
                ? "display-none"
                : "arrow-icon arrow-icon-up cursor-pointer"
            }
            onClick={() => setShowSentiment(false)}
            src={iconsSortUp}
          />
        </Card.Header>
        <Card.Body className={showSentiment ? "" : "display-none"}>
          <Card.Text
            className="overview-second-col-card-text summary fs-14"
            style={{ textTransform: "uppercase" }}
          >
            {document.sentiment_label}
          </Card.Text>
        </Card.Body>
      </Card>
      <span className="document-grid-large-screen-title">
        {t("relatedPublications")}
      </span>
      <Card className="overview-second-col-second-row-first-card document-grid-small-screen-card">
        <Card.Body className="ag-theme-alpine">
          <AgGridReact
            rowData={similarDocuments}
            rowSelection="multiple"
            loadingOverlayComponent={<Loader />}
            pagination
            headerHeight={55}
            paginationPageSize={10}
            onRowClicked={(e) => {
              history.push(GET_DOCUMENT_BY_ID_AWAITING_ID + e.data.id, {
                from: history.location.state
                  ? history.location.state.from
                  : "topic",
              });
            }}
            alwaysShowHorizontalScroll
            scrollbarWidth={15}
          >
            <AgGridColumn
              field="news_title"
              headerName={t("title")}
              width="200px"
              sortable
              filter
              resizable
              wrapText
              autoHeight
            />
            <AgGridColumn
              field="news_type"
              headerName={t("publicationType")}
              cellClass="overview-grid-cell"
              sortable
              filter
              resizable
              width="200px"
            />
            <AgGridColumn
              field="source_country"
              headerName={t("country")}
              cellClass="overview-grid-cell"
              sortable
              filter
              resizable
              width="200px"
            />
            <AgGridColumn
              field="source_name"
              headerName={t("publisher")}
              cellClass="overview-grid-cell"
              sortable
              filter
              resizable
              width="200px"
            />
            <AgGridColumn
              field="source_type"
              headerName={t("typeOfPublisher")}
              cellClass="overview-grid-cell"
              sortable
              filter
              resizable
              width="200px"
            />
            <AgGridColumn
              field="news_date"
              headerName={t("date")}
              cellClass="overview-grid-cell"
              sortable
              filter
              resizable
              width="200px"
              valueFormatter={(params) => {
                return formatDate(new Date(params.value), "dd.mm.yyyy");
              }}
            />
          </AgGridReact>
        </Card.Body>
      </Card>
    </Container>
  );
};

DocumentOverviewSmallContainer.propTypes = {
  document: PropTypes.shape({
    news_summary: PropTypes.news_summary,
    sentiment_label: PropTypes.string,
    keywords: PropTypes.arrayOf(
      PropTypes.shape({
        comment: PropTypes.string,
        description: PropTypes.string,
      })
    ),
    found_dates: PropTypes.arrayOf(
      PropTypes.shape({
        comment: PropTypes.string,
        description: PropTypes.string,
      })
    ),
  }),
  similarDocuments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

DocumentOverviewSmallContainer.defaultProps = {
  document: {},
  similarDocuments: [],
};

export default DocumentOverviewSmallContainer;
